// extracted by mini-css-extract-plugin
export default {"filePage":"File_filePage__k4Zos","fileList":"File_fileList__r1Oui"};